import { BorerShiftDocument } from '../BorerShift/queryBuilder';
import { PanelDocument } from '../Panels/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { ServiceStatusDocument } from '../ServiceStatus/queryBuilder';
import {
  BorerShiftInfoDocument,
  borerShiftInfoPullQueryBuilder,
  borerShiftInfoPushQueryBuilder,
} from './queryBuilder';

export function borerShiftInfoFamilyMember(
  configBuilder: ConfigBuilder,
  borerShift: FamilyMember<BorerShiftDocument>,
  panel: FamilyMember<PanelDocument>,
  serviceStatus: FamilyMember<ServiceStatusDocument>,
): FamilyMember<BorerShiftInfoDocument> {
  const syncConfig = configBuilder<BorerShiftInfoDocument>(RxdbCollectionNameV2.BORER_SHIFT_INFO);
  doNotAutoSync(syncConfig);

  pull(syncConfig, borerShiftInfoPullQueryBuilder);
  push(syncConfig, borerShiftInfoPushQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.BORER_SHIFT_INFO, replicationState, [
    borerShift,
    panel,
    serviceStatus,
  ]);
}
